/* __next_internal_client_entry_do_not_use__ Search auto */ import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import React from "react";
import { createSVGIcon } from "../util";
/**
 * @figma designed by Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=5%3A1749))
 * @trackcomponent
 * @lastsynced 2023-07-10T21:44:59.324Z
 */ export var Search = createSVGIcon(/*#__PURE__*/ _jsxs(_Fragment, {
    children: [
        /*#__PURE__*/ _jsx("path", {
            d: "M0.857178 10.1435C0.857178 12.6063 1.83555 14.9683 3.57707 16.7099C5.31858 18.4514 7.68059 19.4297 10.1435 19.4297C12.6063 19.4297 14.9683 18.4514 16.7099 16.7099C18.4514 14.9683 19.4297 12.6063 19.4297 10.1435C19.4297 7.68059 18.4514 5.31858 16.7099 3.57707C14.9683 1.83555 12.6063 0.857178 10.1435 0.857178C7.68059 0.857178 5.31858 1.83555 3.57707 3.57707C1.83555 5.31858 0.857178 7.68059 0.857178 10.1435V10.1435Z",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
        /*#__PURE__*/ _jsx("path", {
            d: "M23.1429 23.1429L16.7092 16.7092",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    ]
}), "Search", function(strictLocalize) {
    return {
        viewBox: "0 0 24 24",
        titleAccess: strictLocalize({
            id: "BonYS7",
            defaultMessage: [
                {
                    type: 0,
                    value: "Search"
                }
            ]
        }),
        fill: "none",
        color: Core.icon.default
    };
});
